<template>
  <div class="flowCate-slide">
    <div class="w-180 bg-wh" :style="{height: height + 'px'}">
      <div class="p-t-20">
        <div class="h-40 p-l-10 flowCate-item" @click="selectCommon">
          <el-badge :value="allCount">
            <div class="w-100 h-40 p-l-20 fz-14":class="{'c-icon-blue': common == true, 'c-black': common != true }">
              <div v-if='all' >全部</div>
              <div v-else>常用流程</div>
            </div>
          </el-badge>
        </div>
        <div v-for="item in flowCates" class="p-l-10 flowCate-item" @click="selectCate(item)">
          <el-badge class="mark" :value="item.case_num" >
            <div class="w-100 h-40 p-l-20 fz-14 ellipsis ovf-hd" :class="{ 'c-icon-blue': item.selected, 'c-black': !item.selected }">{{item.name}}</div>
          </el-badge>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .ellipsis {
    white-space: nowrap;
    text-overflow: ellipsis;
    -webkit-text-overflow: ellipsis;
    -moz-text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
    -ms-text-overflow: ellipsis;
  }
  .flowCate-slide {
    position: fixed;
    bottom: 0;
    width: 180px;
    overflow: hidden;
    z-index: 2;
  }
  .flowCate-item:hover {
    cursor: pointer;
    background: #f7f9fd;
  }
</style>

<script>
  export default {
    name: 'flowCate',
    props: ['flowCates', 'curIndex', 'all'],
    data() {
      return {
        common: true,
        height: 0
      }
    },
    methods: {
      watchWinSizeChange() {
        window.onresize = () => {
          this.flowCatePos()
          this.height = window.innerHeight - 60
          this.$emit('watchWinSizeChange')
        }
      },
      clearSelectedItem() {
        _(this.flowCates).forEach((res) => {
          res.selected = false
        })
      },
      selectCommon() {
        this.common = true
        this.clearSelectedItem()
        this.$emit('selectCate', 0)
      },
      selectCate(item) {
        this.common = false
        this.clearSelectedItem()
        item.selected = true
        this.$emit('selectCate', item.id)
      },
      flowCatePos() {
        // 解决出现滚动条时，flowCate组件布局错乱
        let body = document.body
        if (document.getElementsByClassName('flowCate-slide').length != 0) {
          let flowCate = document.getElementsByClassName('flowCate-slide')[0]
          let leftMenuWid = document.getElementById('leftMenu').style.width.split('p')[0]
          flowCate.style.left = (leftMenuWid - body.scrollLeft) + 'px'
        }
      }
    },
    created() {
      this.height = window.innerHeight - 60
      this.watchWinSizeChange()
    },
    mounted() {
      let body = document.body
      this.flowCatePos()
      body.onscroll = () => {
        this.flowCatePos()
      }
    },
    watch: {
      'curIndex' (val) {
        if (val == 0) {
          this.common = true
        } else {
          this.common = false
        }
      }
    },
    computed: {
      allCount() {
        let allCount = 0
        _(this.flowCates).forEach((res) => {
          allCount += res.case_num
        })
        return allCount
      }
    }
  }
</script>


// WEBPACK FOOTER //
// flowCate.vue?3b32d292